import { IApplicationState } from '../../../types/types';
import { getActiveBoard } from './getActiveBoard';

export const getActiveBoardLngs = (
    state: IApplicationState
): string[] => {
    const board = getActiveBoard(state);
    return board && board.dashboardSettings && board.dashboardSettings.lngs;
};
